// extracted by mini-css-extract-plugin
module.exports = {"TableDate":"TableDate_TableDate__2IN6q","title":"TableDate_title__1Tzml","text":"TableDate_text__3o-o_","row":"TableDate_row__tLDIn","table-align":"TableDate_table-align__DWl0r"};